import styled from 'styled-components';
import SafeSvg from '../../assets/amenities/safe.svg';

const SafeIcon = styled(SafeSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default SafeIcon;
